import { useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import {
  Button,
  FieldError,
  Form,
  Input,
  Label,
  Modal,
  TextField,
} from "@heroui/react";
import { Icon } from "@iconify/react";

import { useEditCity } from "@/features/city/use-cities.ts";
import { CityEntity } from "@/features/city/type.ts";

interface IFormInput {
  name: string;
}

export function EditCityModal({ city }: { city: CityEntity }) {
  const [isOpen, setIsOpen] = useState(false);

  const { mutateAsync, isPending } = useEditCity();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<IFormInput>();

  const onSubmit: SubmitHandler<IFormInput> = (data) => {
    mutateAsync({
      id: city.id,
      name: data.name.trim(),
      country: "KZ",
    }).then(() => {
      reset();
      setIsOpen(false);
    });
  };

  return (
    <div>
      <Button isIconOnly variant="ghost" onPress={() => setIsOpen(true)}>
        <Icon className="size-6" icon="solar:pen-bold-duotone" />
      </Button>

      <Modal isOpen={isOpen} onOpenChange={setIsOpen}>
        <Modal.Backdrop isDismissable>
          <Modal.Container placement="center">
            <Modal.Dialog>
              <Form onSubmit={handleSubmit(onSubmit)}>
                <Modal.Header>
                  <Modal.Heading>Изменить город</Modal.Heading>
                </Modal.Header>
                <Modal.Body>
                  <TextField
                    defaultValue={city.name}
                    isInvalid={!!errors.name?.message}
                  >
                    <Label>Название города</Label>
                    <Input
                      placeholder="Введите название города"
                      {...register("name", {
                        required: "Нужно заполнить поле",
                      })}
                    />
                    <FieldError>{errors.name?.message}</FieldError>
                  </TextField>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="danger-soft"
                    onPress={() => setIsOpen(false)}
                  >
                    Отмена
                  </Button>

                  <Button isPending={isPending} type="submit" variant="primary">
                    Сохранить
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal.Dialog>
          </Modal.Container>
        </Modal.Backdrop>
      </Modal>
    </div>
  );
}
